module.exports = __webpack_public_path__ + "hero-1.5x-bcc2ee364d7fe68d4ef48ac78a844bfe.webp";